import { render } from "./ModalTriage.vue?vue&type=template&id=66e45960"
import script from "./ModalTriage.vue?vue&type=script&lang=js"
export * from "./ModalTriage.vue?vue&type=script&lang=js"

import "./ModalTriage.vue?vue&type=style&index=0&id=66e45960&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__